import 'swiper/css';
import 'swiper/css/scrollbar';

import React from 'react';
import { IProduct } from '@/models';

interface Props {
  product: IProduct;
  lang: string;
}

const FeedatyRecap: React.FC<Props> = ({ product, lang }) => {
  let dataGui = '';
  switch (lang.toLowerCase()) {
    case 'it':
      dataGui = 'it-IT';
      break;
    case 'de':
      dataGui = 'de-DE';
      break;
    case 'fr':
      dataGui = 'fr-FR';
      break;
    case 'es':
      dataGui = 'es-ES';
      break;
    case 'en':
    default:
      dataGui = 'en-US';
      break;
  }

  return (
    <div
      className="feedaty_widget css-feedaty_widget-recap"
      data-ver="2021"
      data-id="65801272d7a3b"
      data-type="product"
      data-variant="Striscia-slim-blk"
      data-lang="all"
      data-gui={dataGui}
      data-sku={product.selling_code}
      data-snippets="0"
    ></div>
  );
};

export default FeedatyRecap;
